import type { Money } from "@graphql/generated/components";

export interface GetUCIDFromSession {
    market: string;
    externalId: string;
}

export interface OrderHistoryPayload {
    userId?: string;
    email?: string;
    orderId?: string;
    // TODO: Local and Market are not used anymore in HEAP
    locale?: string;
    market?: string;
    pageOffset: number;
    pageSize: number;
    includeChanges: boolean;
}

export interface OrderHistoryResponse {
    pageOffset: number;
    pageCount: number;
    locale: string;
    thereMightBeMoreOrders: boolean;
    orders: Order[];
}

export interface Order {
    totalTax: number;
    totalDiscount: number;
    subTotal: number;
    shippingCost: number;
    orderType: OrderType;
    orderStatus: OrderStatus;
    orderNumber: string;
    orderEmail: string;
    orderDateUtc: string;
    orderCurrency: string;
    netPrice: Money;
    articleCount: number;
    sum: object[];
    lines: Lines[];
    orderChanges: [];
    trackingUrl: string;
    promotionName?: string[];
    hasGiftWrapping?: boolean;
    orderReturnLink?: string;
}

export interface Lines {
    productKey: string;
    name: string;
    productId: string;
    quantity: number;
    paymentStatus: string;
    orderLineId: string;
    itemTax: number;
    itemStatus: LineItemStatus;
    itemNetPrice: Money;
    itemListPrice: Money;
    itemGrossPrice: Money;
    itemDiscount: Money;
    trackingNumber?: string;
    trackingUrl?: string;
    variant: any;
    lineType?: LineType;
    isReturn?: boolean;
}

export enum LineType {
    return = "Return",
    exchange = "Exchange",
    shippingAppeasement = "shipping-appeasement",
    itemAppeasement = "item-appeasement",
}

export enum OrderStatus {
    open = "Open",
    complete = "Complete",
    cancelled = "Cancelled",
    returned = "Returned",
}

export enum LineItemStatus {
    notConfirmed = "Not confirmed",
    pending = "Pending",
    shipped = "Shipped",
    complete = "Complete",
    readyForPickUp = "Ready for pick up",
    pickedUp = "Picked up",
    cancelledNotPickedUp = "Cancelled - Not picked up",
    cancelledOutOfStock = "Cancelled - Out of stock",
    Cancelled = "Cancelled",
    //Maybe we need to remove this once it will be fixed on BE side
    returned = "Returned",
}

export enum OrderType {
    pos = "POS",
    ecom = "ECOM",
    sendsale = "SENDSALE",
    dropship = "DROPSHIP",
    orderInStore = "ORDERINSTORE",
    clickAndCollect = "CLICK_COLLECT",
    clickAndReserve = "CLICK_RESERVE",
    reserveInStore = "RESERVEINSTORE",
}
